import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "m7.813 13.741 4.147-4.147a.97.97 0 0 0 0-1.37L7.813 4.078a.898.898 0 0 0-1.266 0l-.244.244a.898.898 0 0 0 0 1.266l2.636 2.636a.97.97 0 0 1 0 1.37L6.303 12.23a.898.898 0 0 0 0 1.267l.244.244a.898.898 0 0 0 1.266 0Z"
    }, null, -1)
  ]))]))
}
export default { render: render }